<template>
    <div>
        <b-tabs>
        <b-tab active>
            <template slot="title">
                <h6>Registro de Entradas</h6>
            </template>
            <template>
                <stock></stock>
            </template>
        </b-tab>
        <b-tab>
            <template slot="title">
                <h6>Ajuste de Inventario</h6>
            </template>
            <template>
                <ajuste-inventario></ajuste-inventario>
            </template>
        </b-tab>
        <b-tab>
            <template slot="title">
                <h6>Kardex</h6>
            </template>
            <template>
                <kardex></kardex>
            </template>
        </b-tab>
        </b-tabs> 
    </div>
</template>

<script>
import Stock from '@/components/stock/Stock'
import AjusteInventario from '@/components/stock/AjusteInventario'
import Kardex from '@/components/stock/Kardex'
export default {
    components:{
        Stock,
        AjusteInventario,
        Kardex
    },
    data:()=>{
        return{

        }
    },
}
</script>